import React from 'react'

import { IDialogContext } from './dialog.types'

export const DialogContext = React.createContext<IDialogContext | null>(null)
